import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import { useLazyGetValuationListQuery } from '~/redux/api/valuationApiSlice';
import EmptyTabContent from '~valuation/pages/MyValuations/EmptyTabContent';
import EstimationsList from '~valuation/pages/MyValuations/Estimations/EstimationsList';
import Pagination from '~/components/Pagination';
import ValuationItemLoader from '~valuation/pages/MyValuations/ValuationItemLoader';
import { useBreakpoint } from '~/hooks';

export default function EstimationTabContent() {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const [page, setPage] = useState<number>(1);
  const [getValuationList, { data, isFetching, isLoading }] =
    useLazyGetValuationListQuery();
  const { mobileScreen } = useBreakpoint();

  const handleGetValuationList = useCallback(
    (page: number) => {
      getValuationList({
        page,
        limit: 3,
        type: ValuationTypeEnum.ESTIMATION,
        locale,
      });
    },
    [locale],
  );

  useEffect(() => {
    handleGetValuationList(1);
  }, [locale, handleGetValuationList]);

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4x">
        <Skeleton
          height={12}
          width={mobileScreen ? 200 : 700}
          borderRadius={12}
        />
        <div className="flex flex-col gap-3x">
          {Array(2)
            .fill(0)
            .map((_, i) => (
              <ValuationItemLoader key={i} />
            ))}
        </div>
      </div>
    );
  }

  if (!data?.valuations.length) {
    return (
      <EmptyTabContent
        title={t('valuationEmptyTitle')}
        description={t('valuationEmptyDescription')}
        icon="evaluate-property"
      />
    );
  }

  return (
    <div className="flex flex-col gap-3x md:gap-4x ">
      <p className="text-body_1 text-gray__dark_1">{t('estimationsTitle')}</p>
      <div className="flex flex-col gap-3x md:gap-4x ">
        <EstimationsList
          estimations={data?.valuations}
          isFetching={isFetching}
        />
        <Pagination
          currentPage={page}
          onPageChange={(newPage) => {
            setPage(newPage);
            handleGetValuationList(newPage);
          }}
          totalCount={data?.paginate.totalCount}
          limit={data?.paginate.limit}
        />
      </div>
    </div>
  );
}
